import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDataTable,{attrs:{"headers":_vm.headers,"items":_vm.remittanceConfigurations,"loading":_vm.isLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }